import { render, staticRenderFns } from "./radio.component.vue?vue&type=template&id=0b042c34&scoped=true"
import script from "./radio.component.vue?vue&type=script&lang=ts"
export * from "./radio.component.vue?vue&type=script&lang=ts"
import style0 from "./radio.component.vue?vue&type=style&index=0&id=0b042c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b042c34",
  null
  
)

export default component.exports